.note {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 14px;
  margin-bottom: 22px;
  padding: 14px 20px;
  background: var(--band);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 24px;
  line-height: 1.1;
}

.text {
  margin: 0;
  flex: 1 1 280px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary);
}

@media (min-width: 1024px) {
  .note {
    margin-bottom: 26px;
    padding: 16px 24px;
  }
}
